<!-- <app-cvx-header
    [pTitle]="APP_CONFIG.appTitle"
    [pFullName]="profileName()"
    [pSRCImageProfileUser]="imagenUrl()"
/>

<app-cvx-navbar 
    [pMenuItems]="navbarMenuItems()"/>

<app-cvx-main /> -->
<app-loading></app-loading>
<router-outlet></router-outlet>